export class NaviRequest extends Request {

    static readonly STORE: string = 'store';
    static readonly DELETE: string = 'delete';
    static readonly TARGET_SALARY: string = 'salary';
    static readonly TARGET_SALES: string = 'sales';
    static readonly TARGET_EMPLOYEES: string = 'employees';
    static readonly TARGET_AVERAGE_ANNUAL_SALARY: string = 'average_annual_salary';

    public constructor(url: string, options: Object) {
        super(url, options);
    }

    //GET基本
    private static createGet(url, params?: object) {
        if (params) {
            let urlParams = new URLSearchParams();
            for (let key in params) {
                let value = params[key];
                if(Array.isArray(value)){
                    value.forEach( val =>{
                        urlParams.append(`${key}[]`, val);    
                    })
                }else{
                    urlParams.append(key, value);    
                }
            }
            url += '?' + urlParams;
        }
        return new NaviRequest(url, {method: "GET"});
    }

    //GETのURLパラメータをObjectから生成
    private static makeGetUrl(baseUrl: string, params: object) {
        let urlParams = new URLSearchParams();
        for (let key in params) {
            let value = params[key];
            urlParams.append(key, value);
        }
        return urlParams;
    }


    //検索
    public static createSearch(conditionParams: object): NaviRequest {
        return this.createGet('/search', conditionParams);
    }


    //POST基本
    private static createPost(url, body: object): NaviRequest {
        return new NaviRequest(url, {
            method: "POST",
            body: JSON.stringify(body),
            headers: NaviRequest.getDefaultApiHeaders()
        });
    }

    //デフォルトリクエストヘッダー
    private static getDefaultApiHeaders(): any {
        let token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
        return {
            'X-CSRF-TOKEN': token,
            'Content-Type': 'application/json'
        };
    }


    //お気に入り登録・解除
    public static createFavorite(company_id: number, type: string) {
        return this.createPost('/favorite/update', {
            company_id: company_id,
            update_type: type
        });
    }

    //履歴解除
    public static createBrowsingDelete(company_id: number) {
        return this.createPost('/browsing/delete', {
            company_id: company_id
        });
    }

    //検索履歴削除
    public static createSearchDelete(search_id: number) {
        return this.createPost('/search/delete', {
            search_id: search_id
        });
    }

    //シミュレーション保存
    public static createSimulation(company_id: number, params: object) {
        return this.createPost(`/companies/${company_id}/simulation`, params);
    }

    //シミュレーション削除
    public static createSimulationDelete(simulation_id: number) {
        return this.createPost(`/simulation/delete`, {
            simulation_id: simulation_id
        });
    }

    //動画再生
    public static createPlayVideo(id: number) {
        return this.createPost(`/api/videos/${id}/play`, {});
    }

    //採用ページへのリンク
    public static createRecruitLink(company_id: number, click_url: string) {
        return this.createPost(`/api/track-click`, {
            company_id: company_id,
            click_type: 'recruitment_page',
            click_url: click_url
        });
    }


}